ApplicationAdapter = require './application'
NestedResource      = require 'mixins/nested-resource'

module.exports = App.RestaurantPriceAdapter = ApplicationAdapter.extend NestedResource,
  parentType:         'draft_dish'
  parentRelationship: 'restaurant_prices'
